import { createContext } from "react";

export interface PopoversContextProps {
  showPopovers: (selector?: string) => void;
  showPopover: (element: HTMLElement) => void;
  hidePopover: (element: HTMLElement) => void;
  hidePopovers: () => void;
}

export const PopoversContext = createContext({} as PopoversContextProps);
